import ServerDirections from '@/config/server-directions'
import { BookingType } from '@/entities/BookingType'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

export class BookingTypeRequests {
  list () {
    const route = ServerDirections.BOOKING_TYPES
    const method = 'get'
    function map (data) {
      return data.map(item => new BookingType(item))
    }
    return requestService.makePromise(route, method, {}, map)
  }
}
